import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Configure Axios base URL
axios.defaults.baseURL = 'https://exam.doode.in';

const StudentRegister = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    fullName: '',
    admissionNo: '',
    collegeName: '',
  });
  
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('error');
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    
    if (formData.password !== formData.confirmPassword) {
      setMessage('Passwords do not match');
      setMessageType('error');
      return;
    }
    
    if (formData.password.length < 6) {
      setMessage('Password must be at least 6 characters long');
      setMessageType('error');
      return;
    }
    
    try {
      const submissionData = {
        username: formData.username,
        password: formData.password,
        email: formData.email,
        fullName: formData.fullName,
        admissionNo: formData.admissionNo || "NA",
        collegeName: formData.collegeName || "NA",
        accountType: "portalCreated"
      };
      
      console.log("Frontend - Submitting with accountType:", submissionData.accountType);
      
      const res = await axios.post('/api/student/register', submissionData, {
        headers: {
          'Content-Type': 'application/json',
          'X-Preserve-Fields': 'accountType'
        }
      });
      
      if (res.data && res.data.message === 'Student registered successfully') {
        setMessage('Registration successful! Redirecting to login...');
        setMessageType('success');
      
        setTimeout(() => {
          navigate('/student-login');
        }, 2000);
      } else {
        setMessage(res.data?.message || 'Registration failed. Please try again.');
        setMessageType('error');
      }
      
    } catch (err) {
      console.error('Registration error:', err);
      setMessage(err.response?.data?.message || 'Registration failed. Please try again.');
      setMessageType('error');
    }
  };

  const handleCloseMessage = () => {
    setMessage('');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '100vh',
      }}
    >
      {/* Left Image Section */}
      <div
        style={{
          flex: '0 0 60%',
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Right Registration Section */}
      <div
        style={{
          flex: '0 0 40%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)',
          padding: '10px',
          overflowY: 'hidden',
          position: 'relative',
        }}
      >
        {/* Card Section */}
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
          }}
        >
          <h3 style={{ textAlign: 'center', marginBottom: '16px', color: 'purple', fontFamily: "'Roboto', sans-serif" }}>
            Student Registration
          </h3>
          {/* Message Section - Moved inside card, under heading */}
          {message && (
            <div
              style={{
                backgroundColor: '#F3E8FF',
                color: '#6B21A8',
                fontFamily: "'Roboto', sans-serif",
                padding: '8px',
                borderRadius: '8px',
                textAlign: 'center',
                fontSize: '14px',
                maxWidth: '300px',
                width: '100%',
                margin: '0 auto 16px auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                animation: 'slideInFromRight 0.5s ease-out',
              }}
            >
              <span style={{ fontFamily: "'Roboto', sans-serif" }}>{message}</span>
              <FontAwesomeIcon
                icon={faTimes}
                style={{
                  cursor: 'pointer',
                  fontSize: '12px',
                  color: '#6B21A8',
                  fontFamily: "'Roboto', sans-serif",
                }}
                onClick={handleCloseMessage}
                aria-label="Close message"
              />
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center',
              marginTop: '2rem',
            }}
          >
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                fontFamily: "'Roboto', sans-serif",
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <button
              type="submit"
              style={{
                padding: '5px 20px',
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'purple',
                fontWeight: 'bold',
                fontSize: '14px',
                border: '2px solid transparent',
                borderRadius: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '12px',
                maxWidth: '300px',
                width: '45%',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                fontFamily: "'Roboto', sans-serif",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.03)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              }}
            >
              Register Account
            </button>
            <div style={{ textAlign: 'center', marginTop: '12px', fontFamily: "'Roboto', sans-serif", width: '100%' }}>
              <span style={{ fontFamily: "'Roboto', sans-serif" }}>Already have an account?</span>
              <Link
                to="/student-login"
                style={{
                  textDecoration: 'none',
                  color: 'purple',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'text-decoration 0.3s ease',
                  marginLeft: '6px',
                  fontFamily: "'Roboto', sans-serif",
                }}
                onMouseOver={(e) => {
                  e.target.style.textDecoration = 'underline';
                }}
                onMouseOut={(e) => {
                  e.target.style.textDecoration = 'none';
                }}
              >
                Login
              </Link>
            </div>
          </form>
        </div>
      </div>
      <style>
        {`
          @keyframes slideInFromRight {
            0% {
              transform: translateX(100%);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default StudentRegister;